import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { Link as RouterLink, generatePath } from 'react-router-dom';
import { PATH } from '@constants';
import { Module } from './CursoAulasPage.types';
import { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { CursoAulasQuery } from './CursoAulasPage.graphql';
import ConteudoCheckBox from 'components/ConteudoCheckBox';

function CursoAulasPageAccordion({
  cursoId,
  materiaId,
  modules,
  refetchAulas,
}: {
  cursoId: string;
  materiaId: string;
  modules: Module[];
  refetchAulas: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<CursoAulasQuery>>;
}) {
  return (
    <Box overflow="auto" sx={{ pr: 4 }}>
      {modules.map((module) => (
        <Accordion key={module.id} defaultExpanded>
          <AccordionSummary>
            <Typography variant="h4">{module.nome}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <List sx={{ width: '100%' }} disablePadding>
              {module.conteudos.map((content) => (
                <ListItem key={content.id} disablePadding divider>
                  <ListItemButton
                    role={undefined}
                    dense
                    component={RouterLink}
                    to={generatePath(PATH.aula, {
                      cursoId,
                      materiaId,
                      conteudoId: content.id,
                    })}
                  >
                    <ListItemIcon>
                      <ConteudoCheckBox
                        {...{ cursoId, materiaId, refetchAulas }}
                        conteudoId={content.id}
                        assistido={content.assistido}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={content.nome}
                      secondary={content.professor}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}

export default CursoAulasPageAccordion;
